export type DataGridTreeFolderHandle = {
  activeFolderId?: string;
  includeSubfolders: boolean;
};
